import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LoaderStyles from "./Loader.module.scss";
const Loader = () => (_jsxs("div", Object.assign({ className: LoaderStyles.ldsRing }, { children: [_jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {})] })));
export { Loader };
